import PropTypes from "prop-types";
import React from "react";

export const ConfirmationModal = ({
  isOpen,
  onClose,
  onDelete,
  header,
  message,
  cancelBtn,
  confirmBtn,
}) => {
  const confirmBtnText = confirmBtn ?? "Delete";
  const cancelBtnText = cancelBtn ?? "Cancel";
  return (
    isOpen && (
      <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white p-6 rounded-lg w-1/4 sm:block sm:p-0">
          <div className="fixed inset-0 transition-opacity">
            <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>
          <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:align-middle sm:max-w-lg sm:w-full">
            <div className="bg-white px-3 pt-4 pb-3 sm:p-4 sm:pb-3">
              <div>
                <div className="mt-2">
                  <div className="bg-white overflow-hidden">
                    <div className="px-4 py-5 sm:px-6">
                      <h3 className="text-lg leading-6 font-medium text-gray-900">
                        {header}
                      </h3>
                    </div>
                    <div className="px-4 py-5 sm:p-0">{message}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={onClose}
                  className="mr-2 px-4 py-2 bg-teal-600 rounded hover:bg-teal-700"
                >
                  {cancelBtnText}
                </button>
                <button
                  type="button"
                  onClick={onDelete}
                  className="px-4 py-2 bg-sky-800 text-white rounded hover:bg-sky-900"
                >
                  {confirmBtnText}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  header: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  cancelBtn: PropTypes.string,
  confirmBtn: PropTypes.string,
};
